import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../ts/Glob';

import WidgetParametersEdit from './WidgetParametersEdit';
import { ParameterField } from '../../../_common/platform/tsx/ParameterField';
import { WidgetData } from '../../../_common/platform/ts/WidgetData';

import StringField from '../../../_common/platform/tsx/StringField';

function getWidgetData(data, glob: IGlob) {
    const res = WidgetData.getFromObj(data, glob, false);
    return {
        widgetData: res
    };
}

export class Header extends React.Component<
    {
        data;
        sharedState: {
            selected;
        };
        onSelect(value: { name: boolean; title: string; view: string });
        setContainerSize();
        close();
        glob: IGlob;
    },
    {
        widgetData: WidgetData;
        title: string;
        view: string;
        editViews;
    }
> {
    //LL: 20.01.25 
    private references: {
        selectedFieldEditView?: HTMLElement; // HTMLDivElement;
    } = {};

    constructor(props) {
        super(props);

        this.state = _.extend({}, getWidgetData(this.props.data, this.props.glob), {
            title: '',
            view: '__main',
            editViews: null
        });
    }

    componentDidUpdate(prevProps, prevState) {
        var updateSize = prevState.editViews != this.state.editViews || prevState.view != this.state.view;

        if (updateSize && typeof this.props.setContainerSize === 'function') {
            this.props.setContainerSize();
        }
    }

    componentWillReceiveProps(nextProps) {
        var params = this.state.widgetData.widget.parameters;
        var param;

        if (
            this.props.sharedState.selected !== nextProps.sharedState.selected &&
            nextProps.sharedState.selected != null
        ) {
            param = params[nextProps.sharedState.selected];

            const newState = _.extend({}, getWidgetData(nextProps.data, this.props.glob), {
                title: param.title,
                view: '__main',
                editViews: param.collectEditViews(this.state.widgetData.widget.values[nextProps.sharedState.selected])
            });

            this.setState(newState);
        }
    }

    changeTitle = (val) => {
        this.setState({
            title: val
        });
    };

    changeView = (e) => {
        this.setState({
            view: (this.references.selectedFieldEditView as HTMLInputElement).value
        });
    };

    handleAdd = (e) => {
        if (typeof this.props.onSelect === 'function') {
            this.props.onSelect({
                name: this.props.sharedState.selected,
                title: this.state.title,
                view: this.state.view
            });

            this.props.close();
        }
    };

    getParamView = (param, name) => {
        var editView = this.state.editViews[this.state.view];
        if (editView == null) {
            return;
        }

        var EditComponent = editView.Component;

        var data = this.state.widgetData;

        var _self = this;

        return [
            <div className="row" key="div_row">
                <div className="col-sm-6">
                    <div className="form-group">
                        <label>
                            <span>{'Field Title'}</span>
                        </label>

                        <StringField value={this.state.title} onChange={this.changeTitle} />
                    </div>
                </div>

                <div className="col-sm-6">
                    <div className="form-group">
                        <label>
                            <span>{'Edit View'}</span>
                        </label>

                        <select
                            ref={(input) => {
                                this.references.selectedFieldEditView = input;
                            }} //LL: 20.01.25
                            className="form-control"
                            value={this.state.view}
                            onChange={this.changeView}
                        >
                            {_.map(_.keys(this.state.editViews), function (key, i) {
                                var obj = _self.state.editViews[key];

                                return (
                                    <option key={i} value={key}>
                                        {obj.title}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                </div>
            </div>,

            <div className="component-preview" key="div_comp-prev">
                <div className="component-preview-title">{'Preview'}</div>

                <ParameterField
                    param={param}
                    widgetId={data.id}
                    widgetType={data.type}
                    fieldName={name}
                    selectMode={true}
                    title={this.state.title}
                    options={param.getOptions() || {}}
                    glob={this.props.glob}
                >
                    <EditComponent
                        title={this.state.title}
                        value={editView.input(data.widget.values[name])}
                        values={data.widget.values}
                        param={param}
                        options={editView.componentOptions || {}}
                        glob={param.glob}
                        {...editView.componentProps}
                    />
                </ParameterField>
            </div>,

            <div key="div_btn" className="btn btn-xs btn-success" onClick={this.handleAdd}>
                {'Add This Field'}
            </div>
        ];
    };

    // getEmptyView = () => {
    // }

    render() {
        var params = this.state.widgetData.widget.parameters;

        var content;

        if (this.props.sharedState.selected != null) {
            content = this.getParamView(params[this.props.sharedState.selected], this.props.sharedState.selected);
        } //else {
        //     content = this.getEmptyView();
        // }

        return <div className="config-field-select-component-header widget-parameters-edit">{content}</div>;
    }
}

export class Main extends React.Component<
    {
        data;
        onSharedStateUpdate(value: { selected: boolean });
        glob: IGlob;
    },
    {
        widgetData: WidgetData;
    }
> {
    constructor(props) {
        super(props);

        // This is a kind of an anti-pattern
        // It's here here for better performance.
        // The best practice is to calculate WidgetData from the obj
        // on each render.
        this.state = _.extend({}, getWidgetData(this.props.data, this.props.glob));
    }

    componentWillReceiveProps(nextProps) {
        this.setState(getWidgetData(nextProps.data, this.props.glob));
    }

    handleSelect = (value) => {
        if (typeof this.props.onSharedStateUpdate === 'function') {
            this.props.onSharedStateUpdate({
                selected: value
            });
        }
    };

    render() {
        return (
            <div className="config-field-select-component">
                <WidgetParametersEdit
                    id={this.state.widgetData.id}
                    cid={this.state.widgetData.cid}
                    type={this.state.widgetData.type}
                    data={this.state.widgetData.widget}
                    loading={this.state.widgetData.loading}
                    fieldSelectMode={true}
                    //hideLocked={ true }

                    onFieldSelect={this.handleSelect}
                    glob={this.props.glob}
                />
            </div>
        );
    }
}
